/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, June 2022
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import loadingData from './loading';

import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const iloscBudynkow = [
  {
    label: '1 budynek',
    value: '1',
    state: 'iloscBudynkow',
  },
  {
    label: 'więcej niż 1 budynek',
    value: '>1',
    state: 'iloscBudynkow',
  },
];

const dzialkaDict = {
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
  iloscBudynkow: {
    label: 'Ilość budynków*',
    editable: true,
    options: iloscBudynkow,
    type: 'Select',

  },
};


class UstNrPorz extends React.Component {
  state = {
    info: {
      miejscowosc: null,
      iloscBudynkow: '1',
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    acceptRODO: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    miejscowosc: [v.NotNull],
    iloscBudynkow: [v.NotSelected]
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.setState({ isMounted: true });
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        miejscowosc: 'Warszawa',
        iloscBudynkow: '1',
      },
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    const errorText = 'Jeżeli wniosek dotyczy więcej niż jednego budynku lub sytuacja \
    w terenie nie wskazuje jednoznacznie, któremu budynkowi ma zostać ustalony numer \
    porządkowy – do wniosku należy dołączyć mapę lub szkic z ich lokalizacją i oznaczeniem.';
    if (this.state.info.iloscBudynkow !== '1' && (!this.state.attachments || this.state.attachments.length === 0)) {
      this.setState({
        errorText,
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          info: { ...this.state.info },
          selectedParcels: this.state.selectedParcels,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>

        <DecisionContainer
            title={'2. Informacje dodatkowe'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={dzialkaDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
          <p>* - Jeżeli wniosek dotyczy więcej niż jednego budynku lub sytuacja w terenie nie wskazuje jednoznacznie,
            któremu budynkowi ma zostać ustalony numer porządkowy – do wniosku należy dołączyć mapę lub szkic z ich
            lokalizacją i oznaczeniem.
          </p>
        </DecisionContainer>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

UstNrPorz.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UstNrPorz),
);



// WEBPACK FOOTER //
// src/routes/eservices/UstNrPorz.js